import type { Letters } from '#types';
import { typeFn } from '#utils/typeFn';

const fn = typeFn<Letters>()();

export default fn;
